import { render, staticRenderFns } from "./careerMatches.vue?vue&type=template&id=1665cb92&"
import script from "./careerMatches.vue?vue&type=script&lang=js&"
export * from "./careerMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports